import React from "react";

function Canvas_Circles() {
  return (
    <div>
      <h1>Canvas_Circles Component</h1>
      <p>This is the Canvas Circles tutorial page content.</p>
    </div>
  );
}

export default Canvas_Circles;
